'use client';

import { useCouponId, useCouponIndices, useCouponType } from '@svenskaspelab/poolbetting/core/nextjs/coupon';
import { cn } from '@svenskaspelab/poolbetting/ui/utils';
import { type ReactNode } from 'react';

/**
 * Component that renders an empty event footer for layout purposes.
 *
 * @returns Layout component that renders an empty event footer
 */
export function CouponEventLayoutFooter(): ReactNode {
  const [couponId, couponIndex] = useCouponId();
  const couponIndices = useCouponIndices({ couponId });
  const couponType = useCouponType({ couponId, couponIndex });
  const hasMultipleCoupons = couponIndices.length > 1 && couponType === 'singlerows';

  return (
    <span className={cn(`hidden rounded-l-md ${hasMultipleCoupons ? 'h-15 lg:block' : ''} bg-surface-elevated`)} />
  );
}
